module.exports = __webpack_public_path__ + "media/logos/default_logo_large-be94507f.png";